import React, { FunctionComponent } from "react"
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom"
import { ApolloClientProvider } from "./ApolloClientProvider"
import { ManualPage } from "./pages/manualPage/ManualPage"
import { LoginForm } from "./pages/LoginForm"
import { AuthProvider } from "./common/hooks/useAuth"
import { TopBar } from "./components/TopBar"
import { BottomBar } from "./components/BottomBar/BottomBar"
import { FilesPage } from "./pages/filesPage/FilesPage"
import { NavigationBar } from "./components/NavigationBar"
import { NotificationProvider } from "./common/hooks/useNotification"
import { TokensProvider } from "./common/hooks/useTokens"
import { TransactionsPage } from "./pages/transactionsPage/TransactionsPage"
import { ReportsPage } from "./pages/reportsPage/ReportsPage"
import { AuthRoute } from "./AuthRoute"
import { VerifyPage } from "./pages/VerifyPage"
import { ContactUsPage } from "./pages/ContactUsPage"
import styles from "./App.module.scss"
import { BatchPage } from "./pages/batchPage/BatchPage"
import { BrandThemeProvider } from "./components/BrandThemeProvider"

export const App: FunctionComponent<{}> = () => {
    return (
        <>
            <TokensProvider>
                <Router>
                    <NotificationProvider>
                        <ApolloClientProvider>
                            <AuthProvider>
                                <BrandThemeProvider>
                                    <div className={styles.App}>
                                        <TopBar />
                                        <NavigationBar />
                                        <div className={styles.App__content}>
                                            <Switch>
                                                <Route exact path="/login" component={LoginForm} />
                                                <Route
                                                    exact
                                                    path="/verify"
                                                    component={VerifyPage}
                                                />
                                                <Route
                                                    exact
                                                    path="/contact"
                                                    component={ContactUsPage}
                                                />
                                                <AuthRoute path="/batch" component={BatchPage} />
                                                <AuthRoute path="/single" component={ManualPage} />
                                                <AuthRoute path="/files" component={FilesPage} />
                                                <AuthRoute
                                                    path="/transactions"
                                                    component={TransactionsPage}
                                                />
                                                <AuthRoute
                                                    path="/reports"
                                                    component={ReportsPage}
                                                />
                                                <Redirect from="*" to="/single" />
                                            </Switch>
                                        </div>
                                    </div>
                                </BrandThemeProvider>
                            </AuthProvider>
                        </ApolloClientProvider>
                    </NotificationProvider>
                    <BottomBar />
                </Router>
            </TokensProvider>
        </>
    )
}
